module.exports = __webpack_public_path__ + "static/img/wj.444bfd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wj.png
// module id = qqmd
// module chunks = 1